import React from 'react';
import { Chip as HeroChip } from '@heroui/react';

export interface ChipProps {
  children?: React.ReactNode;
  variant?:
    | 'solid'
    | 'faded'
    | 'bordered'
    | 'light'
    | 'flat'
    | 'dot'
    | 'shadow';
  color?: 'default' | 'primary' | 'success' | 'warning' | 'danger';
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  size?: 'sm' | 'md' | 'lg';
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  isDisabled?: boolean;
  isCloseable?: boolean;
  onClose?: () => void;
  className?: string;
  onClick?: () => void;
}

const Chip: React.FC<ChipProps> = ({
  children,
  variant = 'faded',
  color = 'default',
  radius = 'md',
  size = 'md',
  startContent,
  endContent,
  isDisabled = false,
  isCloseable = false,
  onClose,
  className,
  onClick,
}) => {
  return (
    <HeroChip
      variant={variant}
      color={color}
      radius={radius}
      size={size}
      classNames={{ content: 'flex items-center' }}
      startContent={
        startContent ? <div className="px-1">{startContent}</div> : undefined
      }
      endContent={
        endContent ? <div className="px-1">{endContent}</div> : undefined
      }
      isDisabled={isDisabled}
      isCloseable={isCloseable}
      onClose={onClose}
      className={className}
      onClick={onClick}
    >
      {children}
    </HeroChip>
  );
};

export default Chip;
